import React from "react";
import { useSelector } from "react-redux";
import {
    Card,
    CardBody,
    CardTitle
} from "reactstrap";

const LatestActivity = () => {
    const { data} = useSelector(state => ({
        data: state.Dashboard.data,
    }));

    return <Card>
        <CardBody style={{ maxHeight: '576px', minHeight: '200px' }}>
            <CardTitle className="mb-5">Latest Activity</CardTitle>
            <ul className="verti-timeline list-unstyled">
                {
                    data && data.lastestActivity ? data.lastestActivity.map(item => {
                        return <li key={'ltAct' + item.id} className="event-list">
                            <div className="event-timeline-dot">
                                <i className="bx bx-right-arrow-circle font-size-18" />
                            </div>
                            <div className="d-flex">
                                <div className="flex-shrink-0 me-3">
                                    <h5 className="font-size-14">
                                        {item.actionTimeStr}{" "}
                                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                                    </h5>
                                </div>
                                <div className="flex-grow-1">
                                    <div id="activitytext">
                                        {item.activity}
                                    </div>
                                </div>
                            </div>
                        </li>
                    }) :
                        <h6>No data available.</h6>
                }
            </ul>
        </CardBody>
    </Card>
}

export { LatestActivity }